import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Input,
  FormControl,
  FormLabel,
  useColorMode,
} from "@chakra-ui/react";

interface LoadUrlModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  setUrl: (url: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

export function LoadUrlModal({
  isOpen,
  onClose,
  url,
  setUrl,
  onSubmit,
  isLoading,
}: LoadUrlModalProps) {
  const { colorMode } = useColorMode();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent bg={colorMode === "dark" ? "stone.800" : "white"}>
        <ModalHeader>Load from URL</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel fontSize="sm">URL</FormLabel>
              <Input
                placeholder="https://example.com/readme.md"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSubmit()}
              />
            </FormControl>
            <Text fontSize="xs" color="stone.500">
              Enter a URL to a Markdown file. GitHub URLs are automatically
              converted to raw format.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="brand"
            onClick={onSubmit}
            isLoading={isLoading}
          >
            Load
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
